module.exports = "<p>\r\n  gerar-lote works!\r\n</p>\r\n"